import { useScanDeviceApiDetailQuery } from '@hooks/api/useScanDeviceApiDetailQuery';
import type { VrsAccount } from 'types/api';

export const useVrsAccount = useScanDeviceApiDetailQuery<VrsAccount>('/vrs-accounts');
